/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Radio from 'backbone.radio';
import _ from 'lodash';

import GridView from '@/views/GridView';
import ButtonCell from '@/backgrid/ButtonCell';
import StringCell from '@/backgrid/StringCell';
import ExpandableCell from '@/backgrid/ExpandableCell';
import { DateCell } from '@/backgrid/MomentCell';
import PageableCollection from '@/backbone/PageableCollection';

const InProgressAWPackagesGridView = GridView.extend({
  className: 'in-progress-aw-package-grid horizontal-scroll',

  initialize() {
    const self = this;
    this.options.columns = [
      {
        name: 'paddedAWPackageID',
        label: 'AW Package ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'orderIds',
        label: 'Packaged Orders',
        cell: ExpandableCell,
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'regionGroup',
        label: 'Branch',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'assignedEPC',
        label: 'Assigned EPC',
        cell: StringCell,
        headerCell: 'custom',
        width: 16,
        editable: false
      },
      {
        name: 'orderType',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 25,
        editable: false
      },
      {
        name: 'awPackageStatus',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'popStartDate',
        label: 'POP Start Date',
        cell: DateCell,
        headerCell: 'custom',
        width: 12,
        editable: false
      },
      {
        name: 'createdOn',
        label: 'Created On',
        cell: DateCell,
        headerCell: 'custom',
        width: 12,
        editable: false,
        direction: 'ascending'
      },
      {
        name: 'awSystemStatus',
        label: 'AW Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'awSystemReason',
        label: 'Reason',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'openClaimButton',
        label: '',
        width: 8,
        headerCell: 'custom',
        cell: ButtonCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          onClick(e, model) {
            self.viewDetails(e, model);
          }
        }),
        editable: false,
        sortable: false
      }
    ];
    const awPackages = this.model.get('inProgressAWPackages');
    this.padAWPackageIds(awPackages);
    this.options.collection = new PageableCollection(awPackages, { pageSize: 10 });
    this.options.emptyText = 'No In-Progress AW Packages';
  },

  padAWPackageIds(awPackages) {
    _.each(awPackages, (awp) => (awp.paddedAWPackageID = awp.awPackageID.padStart(5, '0')));
  },

  viewDetails(e, model) {
    e.preventDefault();
    Radio.channel('navigate').request('show:int:aw-package', model.get('awPackageID'));
  }
});

export default InProgressAWPackagesGridView;
